import React from 'react';
import Form from '../../components/common/Form';
import {Redirect} from 'react-router-dom';
import Accordion from '../../components/common/Accordion';
import ReactGA from "react-ga";

class KnowledgeBase extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                email: "",
                password: ""
            },
            errors: {},
            source: {}
        };
    }


    componentDidMount() {
        //console.log('opalio jeeeee')
        const {sources, selectedSource} = this.props;

        //let source, onlypage = "";
        let source = "";
        if (sources) {
            source = sources.filter(source =>
                source.id.toString() === selectedSource.toString())[0];
        }

        this.setState({source: source});
    }

    componentDidUpdate=()=> {
        if (this.state.selectedSource !== this.props.selectedSource) {

            const {sources, selectedSource} = this.props;

            //let source, onlypage = "";
            let source = "";
            if (sources) {
                source = sources.filter(source =>
                    source.id.toString() === selectedSource.toString())[0];
            }
            //console.log("v source ", source);
            this.setState({source: source});
        }
    }

    render() {
        //const { sources, selectedSource } = this.props;

        //let source, onlypage = "";
        let source = this.state.source;
        let openModal = this.props.openModal;

        const panels = [
            {
                title: 'What is Emitto?',
                paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.',
            },
            {
                title: 'How to set first feed?',
                paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.',
            },
            {
                title: 'How to set first feed?',
                paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.',
            },
            {
                title: 'How to set first feed?',
                paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.',
            },
            {
                title: 'How to set first feed?',
                paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.',
            },
        ];
        //if (sources)
        //{
        //    source = sources.filter(source =>
        //    source.id.toString() === selectedSource.toString())[0];
        //}
        //console.log("v source ", source);
        if (typeof (source) === 'undefined') {
            return (
                <Redirect to="/workspace-settings"/>
            )
        }
        //console.log("v source ", source && source.web_push_id);
        return (
            <div className="knowledge-base-container">
                <h1 className='main-title'>Knowledge Base</h1>

                <div className="get-started m-lg-b">


                    <h1 className='main-title'>Get Started</h1>
                    <p className='m-lg-b'>Make sure to watch these videos to fully
                        understand
                        how Emitto
                        works.</p>

                    <div className="videos-container row">
                        <div className="col-sm-4">
                            {/*<div className="video" onClick={openModal}*/}
                            {/*id='fb_video_modal'>*/}
                            {/*<span onClick={openModal} id='fb_video_modal'*/}
                            {/*className='far fa-play-circle'></span>*/}
                            {/*</div>*/}
                            {/*<p className='text-bold'>Facebook Chatbot</p>*/}
                        </div>
                        <div className="col-sm-4 bigger-video">
                            <div onClick={openModal} id='webpush_video_modal'
                                 className="video">
                                                                <span onClick={openModal} id='webpush_video_modal'
                                                                      className='far fa-play-circle'></span>
                            </div>
                            <p className="text-bold">Emitto Demo</p>
                        </div>
                        <div className="col-sm-4">
                            {/*<div onClick={openModal} id='overview_video_modal'*/}
                            {/*className="video">*/}
                            {/*<span onClick={openModal} id='overview_video_modal'*/}
                            {/*className='far fa-play-circle'></span>*/}
                            {/*</div>*/}
                            {/*<p className="text-bold">*/}
                            {/*Webpush Setup*/}
                            {/*</p>*/}
                        </div>
                    </div>
                    <span>You can always access this in the Knowledge Base section (bottom
                                    left part of the screen).</span>
                </div>
                <div style={{display: 'none'}}>
                    <div className="segment-container">
                        <h3>Help Topics</h3>
                        <div className="separator"></div>
                        <div className="col-sm-12 col-md-6 no-padding">
                            <div className="help-topics-single">
                                <img src={'/img/sheet_icon.png'}/><p>Emitto Overview</p>
                            </div>
                            <div className="help-topics-single">
                                <img src={'/img/sheet_icon.png'}/><p>Why Should I Use Emitto?</p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 no-padding">
                            <div className="help-topics-single">
                                <img src={'/img/sheet_icon.png'}/><p>Setting up your content distribution</p>
                            </div>
                            <div className="help-topics-single">
                                <img src={'/img/sheet_icon.png'}/><p>Setup Webpush</p>
                            </div>
                            <div className="help-topics-single">
                                <img src={'/img/sheet_icon.png'}/><p>Setup Facebook Chatbot</p>
                            </div>
                            <div className="help-topics-single">
                                <img src={'/img/sheet_icon.png'}/><p>Team Setup</p>
                            </div>

                        </div>
                        <div style={{clear: 'both'}}/>
                    </div>
                    <div className="segment-container">
                        <h3>Frequently Asked Questions</h3>
                        <div className="separator"></div>
                        <div className="col-sm-12 col-md-6 no-padding">
                            <Accordion data={panels}/>
                        </div>
                        <div className="col-sm-12 col-md-6 no-padding">
                            <Accordion data={panels}/>
                        </div>
                        <div style={{clear: 'both'}}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default KnowledgeBase;